import CardDiv from "modules/common/card-div/CardDiv";
import React, {useState } from "react";
import AddClinic from "./AddClinic";
import { Tab, Tabs } from "react-bootstrap";
import AllClinics from "./AllClinics";
import EditClinic from "./EditClinic";

function Clinics() {
  const [activeTab, setActiveTab] = useState("addClinic");
  const [clinicId, setClincId] = useState(null);

  return (
    <>
      <CardDiv
        title={
          <div className="d-flex justify-content-between align-items-center">
            <div className="fs-2">Clinics Management</div>
          </div>
        }
        component={
          <>
            <Tabs
              id="uncontrolled-tab-example"
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
            >
              <Tab
                eventKey="addClinic"
                title="Add a Clinic"
                className="mt-2"
                activeKey={activeTab}
              >
                <AddClinic />
              </Tab>
              <Tab
                eventKey="allClinic"
                title="All Clinic"
                className="mt-2"
                activeKey={activeTab}
              >
                <CardDiv
                  title={<div className="fs-2">All Clinics</div>}
                  component={
                    <>
                      <AllClinics
                        setActiveTab={setActiveTab}
                        setClincId={setClincId}
                      />
                    </>
                  }
                />
              </Tab>
              <Tab
                eventKey="editClinic"
                title="Edit a Clinic"
                className="mt-2"
              >
                {clinicId && <EditClinic clinicId={clinicId} />}
              </Tab>
            </Tabs>
          </>
        }
      />
    </>
  );
}

export default Clinics;
